module.exports = __webpack_public_path__ + "img/icb-empty-elite-e@3x.3f0ebe0a.png";